<template>
  <div>
    <DropdownMenu
      v-model:open="isOpen"
      :modal="false"
    >
      <DropdownMenuTrigger as-child>
        <slot
          :disabled="disabled"
        >
          <button
            :class="{ disabled }"
            type="button"
            class="btn btn-sm btn-info btn-outline-info btn-pill cursor-pointer dropdown-toggle"
          >
            <i class="fal fa-user" />
          </button>
        </slot>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        :disable-portal="disablePortal"
        class="tw:min-w-[280px]"
        :align="contentAlign"
      >
        <DropdownMenuItem
          v-for="{ label, value } in predefinedOptions"
          :key="`TeamMemberFilter_${value}`"
          @select.prevent=""
        >
          <RadioInputField
            v-model="selectedId"
            :value="value"
            :label="label"
            @update:model-value="onRadioChange(value)"
          />
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <div>
          <multiselect
            v-model="selectedMember"
            track-by="id"
            select-label=""
            open-direction="bottom"
            placeholder="Select team member"
            deselect-label="Click to remove"
            tag-placeholder="Add as new contact"
            :options="teamMembersExceptMe"
            label="name"
            :options-limit="10"
            :max-height="600"
            @remove="onRadioChange('')"
            @select="onSelect"
          />
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
</template>

<script>
import { useVModel } from '@vueuse/core'
import { computed, ref, shallowRef } from 'vue'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/shadcn/components/ui/dropdown-menu'
import { RadioInputField } from '@/shadcn/components/ui/radio-group'
import TeamMemberPickerMixin from '../../mixins/team-member-picker-mixin'

export default {
  name: 'TeamMemberFilter',
  components: {
    DropdownMenuSeparator,
    DropdownMenuItem,
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuTrigger,
    RadioInputField,
  },
  mixins: [TeamMemberPickerMixin],
  props: {
    unassigned: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: [String, Number],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disablePortal: {
      type: Boolean,
      default: false,
    },
    contentAlign: {
      // "start" | "center" | "end"
      type: String,
      default: 'start',
    },
  },
  setup(props) {
    const isOpen = ref(false)
    const predefinedOptions = computed(() => {
      const options = [
        {
          value: '',
          label: 'All',
        },
        {
          value: 'me',
          label: 'Me',
        },
      ]

      if (props.unassigned) {
        options.push({
          value: 'null',
          label: 'Unassigned',
        })
      }

      return options
    })

    const selectedMember = shallowRef([])
    const selectedId = useVModel(props)

    const onRadioChange = (value) => {
      selectedMember.value = []
      selectedId.value = value

      isOpen.value = false
    }

    const onSelect = (selectedOption) => {
      selectedId.value = selectedOption.id

      isOpen.value = false
    }

    return {
      isOpen,

      predefinedOptions,
      selectedMember,
      selectedId,

      onRadioChange,
      onSelect,
    }
  },
}
</script>

<style scoped>
  label.radio {
    width:100%;
    margin-bottom: 0;
  }
</style>
